module.exports = __webpack_public_path__ + "static/media/3DPPA42.c921d68f.jpg";